import axios from "axios";
import qs from "qs";

const getProductData = async (productCode, selectedOfferId) => {
  const response = await axios({
    method: "post",
    url: "/bitrix/services/main/ajax.php?mode=ajax&c=orteka:catalog.element&action=getProductData",
    params: {
      productCode,
      selectedOfferId,
    },
  });

  return response.data;
};

const sendRequest = async (name, productCode, phone, id_form) => {
  const response = await axios({
    method: "post",
    url: "/ajax/main_feedback.php",
    params: {
      name,
      productCode,
      phone,
      id_form,
    },
  });

  return response.data;
};

const getBasketData = async () => {
  return axios({
    method: "post",
    url: "/bitrix/services/main/ajax.php?mode=ajax&c=orteka:catalog.element&action=getBasketData",
    params: {},
  });
};

const addToCart = async (offerId) => {
  const response = await axios({
    method: "post",
    url: "/local/ajax/basket.php",
    params: {
      action: "add",
      id: offerId,
    },
  });

  return response.data;
};
const sendReview = async (
  productCode,
  rating,
  text,
  files,
  type,
  name,
  email
) => {
  const response = await axios.postForm(
    "/bitrix/services/main/ajax.php?mode=ajax&c=orteka:catalog.element&action=sendReview",
    qs.stringify({
      productCode,
      rating,
      text,
      files,
      type,
      name,
      email,
    }),
    {
      headers: { "content-type": "application/x-www-form-urlencoded" },
    }
  );

  return response.data;
};

const getInstallmentData = async (price) => {
  const response = await axios.postForm(
    "/bitrix/services/main/ajax.php?mode=ajax&c=orteka:catalog.element&action=getTinkoffData",
    qs.stringify({
      price,
    }),
    {
      headers: { "content-type": "application/x-www-form-urlencoded" },
    }
  );

  return response.data.data;
};

const getRecommendedProducts = async (productCode) => {
  const response = await axios.postForm(
    "/bitrix/services/main/ajax.php?mode=ajax&c=orteka:catalog.element&action=getRecommendedProducts",
    qs.stringify({
      productCode,
    }),
    {
      headers: { "content-type": "application/x-www-form-urlencoded" },
    }
  );

  return response.data;
};

export {
  getProductData,
  sendRequest,
  addToCart,
  getBasketData,
  sendReview,
  getInstallmentData,
  getRecommendedProducts,
};
